import request from '@/router/axios'

const BASE = '/api/produce/meter-energy-analysis'

export function fetchElectricOverview(params) {
  return request({ url: `${BASE}/electric-overview`, method: 'get', params })
}

export function fetchElectricRank(params) {
  return request({ url: `${BASE}/electric-rank`, method: 'get', params })
}

export function fetchWaterOverview(params) {
  return request({ url: `${BASE}/water-overview`, method: 'get', params })
}

export function fetchWaterCompare(params) {
  return request({ url: `${BASE}/water-compare`, method: 'get', params })
}

export function fetchUsageStructure(params) {
  return request({ url: `${BASE}/usage-structure`, method: 'get', params })
}

export function fetchUsageDashboard(params) {
  return request({ url: `${BASE}/usage-dashboard`, method: 'get', params })
}

export function fetchEnergyCompare(params) {
  return request({ url: `${BASE}/energy-compare`, method: 'get', params })
}

export function fetchHeatAnalysis(params) {
  return request({ url: `${BASE}/heat`, method: 'get', params })
}
